// @ts-nocheck
import { Navigate } from "react-router-dom";

function Cover() {
  return <Navigate to="/sign-up" replace />;
}

export default Cover;
